import { ActionTypes } from "./constants";

const setOrg = (payload) => ({
  type: ActionTypes.SET_ORG,
  payload: payload,
});
const addOrg = (payload) => ({ type: ActionTypes.ADD_ORG, payload: payload });
const updateOrg = (payload) => ({
  type: ActionTypes.UPDATE_ORG,
  payload: payload,
});
const deleteOrg = (payload) => ({
  type: ActionTypes.DELETE_ORG,
  payload: payload,
});

const MgtOrgActions = {
  setOrg,
  addOrg,
  updateOrg,
  deleteOrg,
};

export default MgtOrgActions;
